import React from 'react';
import { Link } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { EmptyState } from '../../../components/ui';

export const ADMIN_SHELL_CLASS =
  'release-notes-admin-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8';

// Shown instead of either admin page when the gate fails or the API says 422;
// the editor reuses it, with its own icon and back link, for a deleted note.
const AccessDenied = ({
  icon = LockClosedIcon,
  title = 'Release Notes is for Thisway admins',
  description = 'Ask a Thisway admin for access.',
  backTo = '/dashboard',
  backLabel = 'Back to dashboard',
}) => (
  <div className={ADMIN_SHELL_CLASS}>
    <div className="mx-auto max-w-5xl">
      <EmptyState
        variant="dashed"
        icon={icon}
        title={title}
        description={description}
        action={
          <Link
            to={backTo}
            className="text-sm font-semibold text-blue-600 hover:text-blue-700 dark:text-sky-400"
          >
            {backLabel}
          </Link>
        }
      />
    </div>
  </div>
);

export default AccessDenied;
